import styled, { css } from 'styled-components';
import cores from '../../../styles/cores';

export const ContainerBotao = styled.div`
    display: flex;
`;

export const _ = styled.div``;